// extracted by mini-css-extract-plugin
export default {"headingFontWeightBold":"bold","Mackerel":"#D2D6D9","BreakpointFromLarge":"(min-width: 960px)","modalHeaderHeading":"G2ee1e8 G260343","withSeparator":"G572ad1","alignLeft":"G97669b"};